<template>
  <div class="transition" v-if="props.in.typeEntite === 'entreprise'">
    <BasicText size="h5">
      Veuillez renseigner le SIREN de l'entreprise à rattacher
    </BasicText>
    <div class="transition-items flex-1">
      <WrapperInput
        label="SIREN de l'entreprise"
        v-model="sirenSiret"
        icon-name="entreprise"
      />
      <BasicAlert
        alert-type="info"
        alert-label="Le numéro SIREN est l’identifiant obtenu lors de l’immatriculation de l’entreprise au registre du commerce et des sociétés (RCS). Il est composé de 9 chiffres."
        class="flex-none"
      />
    </div>
  </div>
  <div class="transition" v-else>
    <BasicText size="h5">
      Veuillez renseigner le SIRET de l'établissement à rattacher
    </BasicText>
    <div class="transition-items flex-1">
      <WrapperInput
        label="SIRET de l'établissement"
        v-model="sirenSiret"
        icon-name="entreprise"
      />
      <BasicAlert
        alert-type="info"
        alert-label="Le numéro SIRET est l’identifiant d’un établissement, il est composé du SIREN et du numéro de classement de l’établissement pour un total de 14 chiffres"
        class="flex-none"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import type { DemandeRattachementResult } from '../types'
  import { isSiren, isSiret } from '@/features/shared/tools/luhn'

  import { computed } from 'vue'

  type In = Pick<DemandeRattachementResult, 'typeEntite'>
  type Out = Pick<DemandeRattachementResult, 'sirenSiret'>
  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const sirenSiret = computed({
    get: () => props.out?.sirenSiret,
    set: (value) => {
      value = value?.replaceAll(' ', '')
      const isValid = props.in.typeEntite === 'entreprise' ? isSiren(value) : isSiret(value)
      emits('outChanged', isValid, { sirenSiret: value })
    },
  })
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';

  .transition {
    max-width: 550px;
  }

</style>
